export default "__VITE_ASSET__DCoXbfJx__"